import type { ApiClient } from './client';
import type { OperatorStatus } from '../store/auth';

// ANX-047 — список active-операторов tenant'а для dropdown'а назначения.

export interface OperatorListItem {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'operator';
  // ANX-071: выбранный статус (online/away/busy) + подключён ли сейчас.
  // Эффективный индикатор у коллеги = online ? presenceStatus : 'offline'.
  presenceStatus: OperatorStatus;
  online: boolean;
}

/** ANX-071: эффективный статус оператора для индикатора у коллег.
 *  Не подключён (нет presence) → 'offline' независимо от выбранного. */
export function effectiveStatus(o: { presenceStatus: OperatorStatus; online: boolean }): OperatorStatus | 'offline' {
  return o.online ? o.presenceStatus : 'offline';
}

export async function listOperators(client: ApiClient): Promise<OperatorListItem[]> {
  const raw = await client.request<{ operators: OperatorListItem[] }>('/api/v1/operators');
  return raw.operators;
}
